import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataEntity_Main_11_Interface } from 'src/app/Interface/DataEntity/11/DataEntity_Main_11_Interface';
import { DataEntity_Resolution_11_Interface } from 'src/app/Interface/DataEntity/11/DataEntity_Resolution_11_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataEntity11Service {

  constructor(private http: HttpClient) { }

  GetSingle(id: Number, dataentity_id: number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Dataentityno11/GetSingle?id=" + id
      + "&dataentity_id=" + dataentity_id).pipe(
      map(data => {
        return data as any
      })
    )
  }

  Submit(
    model_temp: DataEntity_Main_11_Interface,
    resolution: Array<DataEntity_Resolution_11_Interface>,
    DataEntity_id: number,
    Calibration_Id: number,
 
    DeviceSerial: string,
    DeviceCode: string,
    
    mvatPh: string,
    responseTime: string,
    value1: string,
    value2: string,
    value3: string,
    value4: string,

    Manufacture_txt: String,
    Model_txt: String,
    LabAddress_txt: String): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');



    var model={
      id:model_temp.id,

      manufacture: Manufacture_txt,
      model: Model_txt,
      
      mvatPh: mvatPh,
      responseTime: responseTime,
      value1: value1,
      value2: value2,
      value3: value3,
      value4: value4,

      unit_nominal: model_temp.unit_nominal,
      
      temperature_Air_before: model_temp.temperature_Air_before +'',
      temperature_Air_after: model_temp.temperature_Air_after+'',

      humidity_Air_before: model_temp.humidity_Air_before+'',
      humidity_Air_after: model_temp.humidity_Air_after+'',

      pressure_before: model_temp.pressure_before+'',
      pressure_after: model_temp.pressure_after+'',

    }

    var body = {
      Calibration_id: Calibration_Id,
      dataentity_id: DataEntity_id,
      model: model,
      resolution : resolution,
      DeviceSerial: DeviceSerial,
      DeviceCode: DeviceCode,
      labAdderss: LabAddress_txt,

    }


    return this.http.post(environment.BaseUrl + "Daro/Dataentityno11/Submit", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

}
